export default {
  accountsTimestamp(state) {
    return state.accountsTimestamp;
  },
  companies(state) {
    return state.companies;
  },
  users(state) {
    return state.users;
  },
};
